import React, { useEffect, useMemo, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/partnerAction";
import * as uiHelpers from "../PartnerUIHelpers";

import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  toastOption,
} from "../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import { usePartnerUIContext } from "../PartnerUIContext";
import { RoleChecker } from "../../../../RoleChecker";
import DeleteModal from "../DeleteModal/DeleteModal";
import { toast } from "react-toastify";
// import { ToastContainer } from 'react-toastify';

const PartnerTable = (props) => {
  // Partner UI Context
  const partnerUIContext = usePartnerUIContext();
  const partnerUIProps = useMemo(() => {
    return {
      queryParams: partnerUIContext.queryParams,
      setQueryParams: partnerUIContext.setQueryParams,
      openEditPartnerPage: partnerUIContext.openEditPartnerPage,
    };
  }, [partnerUIContext]);

  // Getting curret state of partner list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.partner }),
    shallowEqual
  );

  // * MODAL
  const [deleteModal, setDeleteModal] = useState(false);
  const [currentPartner, setCurrentPartner] = useState({});
  const deletePartner = () => {
    dispatch(actions.deletePartner(currentPartner.uuid)).then((res) => {
      toast.success(res.message, toastOption);
      setDeleteModal(false);
      setCurrentPartner({});
      dispatch(actions.fetchPartners(partnerUIProps.queryParams));
    });
  };

  const { totalCount, entities, listLoading } = currentState;

  const dispatch = useDispatch();
  useEffect(() => {
    //Requset ke Branch Action
    dispatch(actions.fetchPartners(partnerUIProps.queryParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerUIProps.queryParams, dispatch]);

  const allowEdit = RoleChecker("Edit", "access_role");

  // Table columns
  const columns = [
    {
      dataField: "name",
      text: "Nama",
      sort: true,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
    },
    // {
    //   dataField: "email_cc",
    //   text: "Email CC",
    //   sort: true,
    // },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditPartnerPage: partnerUIProps.openEditPartnerPage,
        allowEdit,
        setCurrentPartner,
        setDeleteModal,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: partnerUIProps.queryParams.pageSize,
    page: partnerUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <DeleteModal
        show={deleteModal}
        onHide={() => {
          setDeleteModal(false);
          setCurrentPartner({});
        }}
        onClick={deletePartner}
        title="Hapus Mitra"
        content={`Apakah kamu yakin ingin menghapus mitra ${currentPartner.name}?`}
      />
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  partnerUIProps.setQueryParams
                )}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: productsUIProps.ids,
                //   setIds: productsUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default PartnerTable;
